module.exports = __webpack_public_path__ + "static/media/White cellar.c91c85ef.jpg";